import { Commit } from 'vuex';
import { NFCState } from '@/modules/Administrative/store/state';

export enum NFCActions {
    GET_NFC = 'GET_NFC',
    GET_HISTORIQUE_NFC = 'GET_HISTORIQUE_NFC',
    GET_XLS_NFC = 'GET_XLS_NFC'
}

export interface NFCActionTypes {
    commit: Commit;
    state: NFCState;
    getters: any;
}
